import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';

const PointsEarnSummary = ({ total, base, fontSize, ...rest }) => {
  if (total <= 0) {
    return null;
  }

  return (
    <Text data-testid="points-earn-summary-text" color="greys.charcoal" fontSize={fontSize} textAlign="end" {...rest}>
      {'Earn '}
      <PointsEarnDisplay total={total} base={base} fontSize={fontSize} />
      {' Qantas Points^'}
    </Text>
  );
};

PointsEarnSummary.propTypes = {
  total: PropTypes.number.isRequired,
  base: PropTypes.number,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

PointsEarnSummary.defaultProps = {
  base: undefined,
  fontSize: 'sm',
};

export default PointsEarnSummary;
